import React from "react";
import DataTable, { createTheme } from "react-data-table-component";
import "./styles.css";

function ShowTable({Data,columns,title}) {
  const ThemeStyle = {

    headRow: {
      style: {
        backgroundColor: "#E1E0D8",
        color: "#333",
      },
    },
    headCells: {
      style: {
        backgroundColor: "#4CAF50", // Custom background color for the heading
        color: "white", // Custom text color for the heading
        fontSize: "16px", // Font size for the heading
        fontWeight: "bold",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        padding: "12px",
        color: "#555",
      },
    },
    rows: {
      style: {
        minHeight: "72px", // override the row height
        borderBottom: "1px solid #ddd",
      },
    },

    indicator: {
      style: {
        color: "white",
      },
    },
  };

  const conditionalRowStyles = [
    {
      when: (row) => row.index % 2 === 0, // Apply this style to even rows
      style: {
        backgroundColor: "rgba(37, 37, 37, 0.2)", // Light gray background for even rows
        color: "#333",
      },
    },
    {
      when: (row) => row.index % 2 !== 0, // Apply this style to odd rows
      style: {
        backgroundColor: "#E1E0D8", // White background for odd rows
        color: "#333",
      },
    },
  ];
  const coustomeStyle = {
    header: {
      style: {
        fontSize: "22px",
        color: "white",
        backgroundColor: "black",
        minHeight: "56px",
        paddingLeft: "16px",
        paddingRight: "8px",
        fontFamily: "Epilogue",
      },
    },
    pagination: {
      style: {
        backgroundColor: "#E1E0D8", // Background color for pagination controls
        color: "black", // Text color for pagination controls
      },
    },
    headCells: {
      style: {
        backgroundColor: "rgba(37, 37, 37, 0.2);", // Background color for the header cells
        color: "Black", // Text color for the header cells
        fontSize: "14px", // Font size for the header text
      },
    },
    title: {
      style: {
        backgroundColor: "rgba(37, 37, 37, 0.2);", // Background color for the header cells
        color: "Black", // Text color for the header cells
        fontSize: "14px", // Font size for the header text
        fontWeight: "", // Font weight for the header text
        // Padding inside the header cells
      },
    },
    paginationButtons: {
      style: {
        backgroundColor: "white", // Background color for pagination buttons
        color: "white", // Text color for pagination buttons
        border: "none", // Remove default border
        padding: "8px 12px", // Padding around button text
        borderRadius: "4px", // Rounded corners
        margin: "0 4px", // Spacing between buttons
        cursor: "pointer", // Pointer cursor on hover
      },
    }


  }

  return (
    <div className="tables_class" style={{"font-family":"Epilogue"}}>
      <DataTable
    title={title} 
      columns={columns}
      data={Data}
      theme="ThemeStyle"
      customStyles={coustomeStyle}
      conditionalRowStyles={conditionalRowStyles}
      pagination
    />
    </div>
    
  );
}

export default ShowTable;
